import {ThumbnailImage} from "@/components";
import {IMAGE_URL} from "@/constants/general-constants";
import Link from "next/link";
import {useRouter} from "next/router";

export default function CategoryFreelancersCard({data = {}}) {

    const {title = "", freelancers = [], slug = ""} = data;
    const router = useRouter();

    return (
        <Link href={`/category/${router.query.first_level_slug}/${slug}`}
              className="block group bg-pol-light border-2 pr-5 pl-[1.625rem] pt-6 pb-[1.125rem] border-pol-blue-light rounded-l-[1.063rem] rounded-br-[1.063rem] rounded-tr-[1.625rem] hover:brightness-100 hover:border-pol-blue duration-300"
        >
            <p className="max-w-full truncate text-lg font-semibold group-hover:text-pol-blue duration-300">{title}</p>

            <div className="flex justify-between items-center mt-6">
                <div className="flex min-h-[2.875rem]">
                    {
                        freelancers?.map((item, index) => (
                            <ThumbnailImage
                                style={index ? {right: `${-(index * 10)}px`, zIndex: `${index * 10}`} : {}}
                                key={index}
                                classes={{overlayClasses: "group-hover:bg-pol-blue/50"}}
                                title={item.username}
                                image={IMAGE_URL + item.avatar_thumbnail}/>
                        ))
                    }
                </div>
                <i className="icon-simple-arrow-left text-pol-gray-100 text-xs group-hover:text-pol-blue duration-300"/>
            </div>
        </Link>
    )
}
